const prod = {
    API_URL: 'https://sikulik.sk/api'
};
const dev = {
    API_URL: 'http://localhost:8080/api'
};
export const config = process.env.NODE_ENV === 'development' ? dev : prod;
